import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  IconButton,
  Paper,
} from "@mui/material";
import {
  ArrowBack,
  LocalPharmacy,
  Description,
} from "@mui/icons-material";
import chooseMedicine1 from "../Logos/chooseMedicine1.png";
import chooseMedicine2 from "../Logos/chooseMedicine2.png";

import Footer from "../../Components/Common/Footer";
import  bg2 from "../Logos/med_background2.png"



const orderTypes = [
  {
    id: "pharmacy",
    title: "Select Medicines",
    subtitle: "Browse and order medicines from our catalog",
    Icon: LocalPharmacy,
    image: chooseMedicine1,
    color: "#EFF6FF",
    borderColor: "#EFF6FF",
    features: [
      "Wide range of medicines",
      "Instant ordering",
      "No prescription needed",
      "Special discounts",
    ],
  },
  {
    id: "prescription",
    title: "Upload Prescription",
    subtitle: "Upload your prescription for quick delivery",
    Icon: Description,
    image: chooseMedicine2,
    color: "#F0FDF4",
    borderColor: "#EFF6FF",
    features: [
      "Upload prescription photo",
      "We'll arrange medicines",
      "Verified by pharmacist",
      "Doorstep delivery",
    ],
  },
];

const MedicineOrderTypeScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { serviceData } = location.state || {};

  const handleOrderTypeSelect = (orderType) => {
    if (orderType === "pharmacy") {
      navigate("/medicine-list", { state: { orderType, serviceData } });
    } else {
      navigate("/prescription-upload", { state: { orderType, serviceData } });
    }
  };

  return (
    <>
    <Box sx={{ minHeight: "100vh" }}>
      {/* Header */}
      <Paper
        elevation={2}
        sx={{
           backgroundImage: `
              linear-gradient(135deg, rgba(0,109,119,0.9) 0%, rgba(0, 169, 181, 0.68) 100%),
              url(${bg2})
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 2,
            }}
          >
            <IconButton
              onClick={() => navigate("/services")}
              sx={{
                "&:hover": { bgcolor: "#006D77" },
                color:"#ffffff"
              }}
            >
              <ArrowBack />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                fontSize: 40,
                fontWeight: 700,
                color: "#ffffff",
              }}
            >
              Choose Medicine
            </Typography>
            <Box sx={{ width: 40 }} />
          </Box>
        </Container>
      </Paper>

      {/* Content */}
      <Container maxWidth="md" sx={{ py: 4 }}>
        {/* Info Banner */}
        {/* <Paper
          elevation={0}
          sx={{
            bgcolor: "#FEF3C7",
            borderRadius: 3,
            p: 3,
            mb: 4,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <LocalHospital sx={{ fontSize: 48, color: "#D97706" }} />
          <Box>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: "#111827",
                mb: 0.5,
              }}
            >
              Medicine Delivery Service
            </Typography>
            <Typography
              sx={{
                fontSize: 13,
                color: "#6B7280",
              }}
            >
              Choose how you want to order your medicines
            </Typography>
          </Box>
        </Paper> */}

        {/* Order Type Cards */}
        {orderTypes.map((type, index) => (
          <React.Fragment key={type.id}>
            <Card
              elevation={4}
              sx={{
                display: "flex",
                alignItems: "stretch",
                borderRadius: 4,
                overflow: "hidden",
                mb: 4,
                border: `1px solid ${type.borderColor}`,
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 6,
                },
              }}
              onClick={() => handleOrderTypeSelect(type.id)}
            >
              {/* Left: Image Section */}
              <Box
                sx={{
                  width: "30%",
                  backgroundColor: "#f7fbfa",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  p: 3,
                }}
              >
        <img
          src={type.image}
          alt={type.title}
          style={{
            width: "110%",
            height: "auto",
            borderRadius: "12px",
          }}
        />
      </Box>

      {/* Middle: Stats Section */}
      <Box
        sx={{
          width: "20%",
          backgroundColor: "#E8F8E1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 4,
          py: 2,
          mt: 2,    
          mb: 2, 
          ml: 2, 
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)", 
        }}
      >
        <Box textAlign="center">
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: "#153f4b", mb: 0.5 }}
          >
            07
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#4B5563" }}>
            Services
          </Typography>
        </Box>

        <Box textAlign="center">
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: "#153f4b", mb: 0.5 }}
          >
            100+
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#4B5563" }}>
            Happy Clients
          </Typography>
        </Box>
      </Box>

      {/* Right: Text + Features + Button */}
      <CardContent
        sx={{
          width: "50%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          py: 3,
        }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#153f4b", mb: 0.5 }}
          >
            {type.title}
          </Typography>
          <Typography
            sx={{
              fontSize: 14,
              color: "#6B7280",
              mb: 2,
            }}
          >
            {type.subtitle}
          </Typography>

          {/* Feature List */}
          {type.features.map((feature, i) => (
            <Box key={i} sx={{ display: "flex", alignItems: "center", mb: 0.8 }}>
              <Box
                component="span"
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  bgcolor: "#22577A",
                  mr: 1.5,
                }}
              />
              <Typography sx={{ fontSize: 14, color: "#374151" }}>
                        {feature}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                {/* Button */}
                <Box mt={2}>
                  <Button
                    variant="contained"
                    sx={{
                      background: "linear-gradient(90deg, #006D77 0%, #00838F 100%)",
                      color: "#fff",
                      textTransform: "none",
                      borderRadius: "25px",
                      px: 6,
                      py: 0.8,
                      fontSize: 14,
                      fontWeight: 600,
                      "&:hover": {
                        background: "linear-gradient(90deg, #004F55 0%, #006D77 100%)",
                      },
                    }}
                    endIcon={<span>→</span>}
                  >
                    Select
          </Button>
        </Box>
      </CardContent>
    </Card>

        {/* Divider with OR */}
        {index < orderTypes.length - 1 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              my: 2,
            }}
          >
            <Box sx={{ flex: 1, height: "1px", bgcolor: "#D1D5DB", mx: 2 }} />
            <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#6B7280" }}>
          OR
        </Typography>
        <Box sx={{ flex: 1, height: "1px", bgcolor: "#D1D5DB", mx: 2 }} />
              </Box>
            )}
          </React.Fragment>
        ))}


        {/* Help Section */}
        {/* <Box
          sx={{
            mt: 4,
            mb: 4,
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
              color: "#6B7280",
              mb: 1,
            }}
          >
            Need help choosing?
          </Typography>
          <Button
            variant="text"
            onClick={() => navigate("/contactus")}
            sx={{
              fontSize: 14,
              fontWeight: 600,
              color: "#006D77",
              textTransform: "none",
              textDecoration: "underline",
              "&:hover": {
                bgcolor: "transparent",
                textDecoration: "underline",
              },
            }}
          >
            Contact Support
          </Button>
        </Box> */}
      </Container>
    </Box>
    <Footer/>
    </>
  );
};

export default MedicineOrderTypeScreen;